import React, { useState } from 'react';
import { Button, MenuItem, Menu } from '@material-ui/core';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';

import {
  NonprofitNominationStatusType,
  NonprofitNomination,
  OutreachEmailId,
} from 'generated/graphql';
import Img from 'retired/Img';
import Status from 'retired/Status';

import { NOMINATION_STATUS } from './constants';

const NonprofitNominationStatusChip = ({
  nomination,
  handleOpenStatusModal,
  hasGlobalHandleNonprofitNominationsPrivilege,
}: {
  nomination: NonprofitNomination;
  handleOpenStatusModal: (value: NonprofitNominationStatusType) => void;
  hasGlobalHandleNonprofitNominationsPrivilege: boolean;
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | Element>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.SyntheticEvent<Element>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const outreachCompletedCount = nomination.emails
    ? Object.keys(nomination.emails).filter(
        // @NOTE-DP: there's also a __typename in the response, duh
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (key) => key !== '__typename' && nomination.emails?.[key as OutreachEmailId]
      ).length
    : 0;

  return hasGlobalHandleNonprofitNominationsPrivilege ? (
    <>
      <Button
        style={{
          color: NOMINATION_STATUS[nomination.status].textColor,
          backgroundColor: NOMINATION_STATUS[nomination.status].chipColor,
          zIndex: 1,
          marginLeft: 15,
          width: 'max-content',
          opacity: open ? '0.7' : '1',
        }}
        variant="contained"
        disableElevation
        disableRipple
        onClick={handleClick}
        endIcon={<KeyboardArrowDownOutlined />}
      >
        <div>
          {NOMINATION_STATUS[nomination.status].name}
          <Img
            style={{ marginLeft: 20 }}
            src={NOMINATION_STATUS[nomination.status].icon}
            alt="icon"
          />
        </div>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={{ marginTop: 50 }}
        marginThreshold={50}
      >
        {(Object.keys(NOMINATION_STATUS) as Array<keyof typeof NOMINATION_STATUS>)
          .filter(
            (status) =>
              status !== nomination.status ||
              nomination.status === NonprofitNominationStatusType.Outreach
          )
          .map((status) => (
            <MenuItem
              key={nomination.id}
              value={status}
              onClick={(): void => {
                handleClose();
                handleOpenStatusModal(NonprofitNominationStatusType[status]);
              }}
              disabled={
                status === NonprofitNominationStatusType.Outreach &&
                ![
                  NonprofitNominationStatusType.Submitted,
                  NonprofitNominationStatusType.Outreach,
                ].includes(nomination.status)
              }
            >
              {NOMINATION_STATUS[status].name}{' '}
              {status === NonprofitNominationStatusType.Outreach &&
                `(${outreachCompletedCount} of 2)`}
            </MenuItem>
          ))}
      </Menu>
    </>
  ) : (
    <Status
      title={NOMINATION_STATUS[nomination.status].name}
      icon={NOMINATION_STATUS[nomination.status].icon}
      color={NOMINATION_STATUS[nomination.status].chipColor}
      textColor={NOMINATION_STATUS[nomination.status].textColor}
      style={{ width: 'max-content' }}
    />
  );
};

export default NonprofitNominationStatusChip;
